import React from 'react';
import ReportDrilldownPage from './ReportDrilldownPage';

const TransactionDrilldownReport = () => <ReportDrilldownPage type="transaction" />;

export default TransactionDrilldownReport;
